import { getBuilderImageResizeUrl } from "@ui/utils/getBuilderImageResizeUrl";
import { getOptimizedBackgroundImage } from "@ui/utils/getOptimizedBackgroundImage";

import { LongArrowForwardIcon } from "@jti/brand-icons/long-arrow-forward";
import { Button } from "@jti/core-components/components/Button";

import styles from "./NotFound.module.scss";

type NotFoundProps = {
  title: string;
  subtitle?: string;
  backgroundImageUrl?: string;
  cta?: {
    label: string;
    href: string;
  };
};

const NotFound: React.FC<NotFoundProps> = ({ title, subtitle, backgroundImageUrl, cta }) => {
  const resizedBackgroundImageUrl = getBuilderImageResizeUrl({ imageUrl: backgroundImageUrl });
  const optimizedBackgroundImage = resizedBackgroundImageUrl
    ? getOptimizedBackgroundImage(resizedBackgroundImageUrl)
    : undefined;

  return (
    <div
      className={styles.wrapper}
      style={optimizedBackgroundImage ? { "--background-image": optimizedBackgroundImage } : undefined}
      data-testid="404-content-block-wrapper"
    >
      <div className={styles.content}>
        <h1 className={styles.title}>{title}</h1>
        {subtitle && <h2 className={styles.subtitle}>{subtitle}</h2>}
      </div>
      {cta && (
        <Button variant="text-muted" href={cta.href} iconAfter={LongArrowForwardIcon}>
          {cta.label}
        </Button>
      )}
    </div>
  );
};

export { NotFound };
